import { DeletePage } from '../crud/shared.js';

export class BrandsDelete extends DeletePage {
  static get formAction() {
    return API.resourceUrl('brands', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Brands" href="/brands" nameHref="/brands/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="Delete" suffixStyle="" suffixSeparatorStyle="">

    form.stacked-form[method="DELETE" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/brands"]
      p Please confirm deleting this item.
      .horizontal-flex.mt-15
        <FormButton label="Confirm Delete">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}"] Back
  `;

  static javascript() {
    API.get(API.resourceUrl('brands', Routing.params.id))
      .then(data => {
        document.querySelector('#name').innerHTML = data.data.name;
      });
  }
}
